import React from 'react';
import { avatarFor, initialsFor } from '../lib/avatar';

/**
 * Round portrait used across the hub. When `photo` is a URL we render
 * the image; otherwise we fall back to the deterministic colored-initials
 * tile. Callers can pass either an Employee row (`emp` prop) or the
 * individual fields they already have.
 */
export default function EmployeeAvatar({ fullName, email, photo, size = 40, className = '' }) {
  const { bg, fg } = avatarFor(email || fullName);
  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        className={`inline-block rounded-full object-cover shrink-0 select-none ${className}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
    );
  }
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full shrink-0 select-none ${className}`}
      style={{
        background: bg, color: fg,
        width: size, height: size,
        fontWeight: 600,
        fontSize: Math.round(size * 0.36),
        letterSpacing: '0.02em',
      }}
      aria-hidden="true"
    >
      {initialsFor(fullName, email)}
    </div>
  );
}
